import React from "react";

const SITE_URL = process.env.REACT_APP_SITE_URL || "https://www.korehalal.com";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

/**
 * Reusable per-route SEO/meta block.
 *
 * Renders title + description + canonical + Open Graph + Twitter Card
 * (and optional JSON-LD) consistently. React 19 hoists title/meta/link into
 * <head> client-side; JS-rendering crawlers (Googlebot) pick them up per route.
 *
 * Props:
 *  - title, description: required text
 *  - path: route path (e.g. "/halal-map"); canonical/og:url = SITE_URL + path
 *  - image: absolute image URL (defaults to the site og-image)
 *  - type: og:type ("website" | "article" | "product" | ...)
 *  - noindex: when true, adds robots noindex,follow
 *  - jsonLd: object (or array) serialized into a JSON-LD <script>
 */
export default function Seo({
  title,
  description,
  path = "",
  image,
  type = "website",
  noindex = false,
  jsonLd,
}) {
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;

  return (
    <>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, follow" />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Korehalal Trip" />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </>
  );
}
